import { Component } from 'react';

export default class Api extends Component {
    static isStaging = false;

    static baseUrl = Api.getBaseUrl();

    static IMAGE_URL = Api.getImageBaseUrl();

    static loginUrl = `${Api.baseUrl}login/`;

    static logoutUrl = `${Api.baseUrl}logout/`;

    static changePassUrl = `${Api.baseUrl}change-password/`;

    static profileUrl = `${Api.baseUrl}profile/`;

    static countryListUrl = `${Api.baseUrl}countries/`;

    static statesListUrl = `${Api.baseUrl}states/`;

    static cityListUrl = `${Api.baseUrl}city/`;

    static localityReoderUrl = `${Api.baseUrl}locality-reorder/`;

    static cityReoderUrl = `${Api.baseUrl}city-reorder/`;

    static stateReoderUrl = `${Api.baseUrl}state-reorder/`;

    static countryReoderUrl = `${Api.baseUrl}country-reorder/`;

    static usersUrl = `${Api.baseUrl}users/`;

    static adminUsersUrl = `${Api.baseUrl}admin-users/`;

    static usersStatusUrl = `${Api.baseUrl}users-status-change/`;

    static rolesUrl = `${Api.baseUrl}roles/`;

    static uploadUrl = `${Api.baseUrl}upload/`;

    static localitiesUrl = `${Api.baseUrl}localities/`;

    static extraFeaturesUrl = `${Api.baseUrl}extra-features/`;

    static featureGroupUrl = `${Api.baseUrl}feature-group/`;

    static propGroupUrl = `${Api.baseUrl}property-group/`;

    static categoriesUrl = `${Api.baseUrl}categories/`;

    static categoriesStatusUrl = `${Api.baseUrl}categories-status-change/`;

    static basicSettingsUrl = `${Api.baseUrl}basic-settings/`;

    static notificationsUrl = `${Api.baseUrl}notification/`;

    static adminCountUrl = `${Api.baseUrl}admin-count/`;

    static walletUrl = `${Api.baseUrl}wallet/`;

    static updateWalletUrl = `${Api.baseUrl}update-wallet/`;

    static categoryReorderUrl = `${Api.baseUrl}category-order/`;

    static extraFeatureReorderUrl = `${Api.baseUrl}extra-feature-order/`;

    static attributeUrl = `${Api.baseUrl}attributes/`;

    static attributeReorderUrl = `${Api.baseUrl}attributes-order/`;

    static attributeStatusUrl = `${Api.baseUrl}attribute-status-change/`;

    static attributePropsUrl = `${Api.baseUrl}attr-property/`;

    static attributeByCatUrl = `${Api.baseUrl}cat-attributes/`;

    static attributeAssignUrl = `${Api.baseUrl}attribute-assign/`;

    static customNotificationsUrl = `${Api.baseUrl}custom-notification/`;

    static notificationsCntUrl = `${Api.baseUrl}notification-count/`;

    static paymentsUrl = `${Api.baseUrl}payment-history/`;

    static adsUrl = `${Api.baseUrl}advertise/`;

    static adsListUrl = `${Api.baseUrl}advertise-list/`;

    static ordersUrl = `${Api.baseUrl}orders/`;

    static adsStatusChangeUrl = `${Api.baseUrl}advertise-status-change/`;

    static followUrl = `${Api.baseUrl}follows/`;

    static supportChatUrl = `${Api.baseUrl}support-chat/`;

    static supportCategoryUrl = `${Api.baseUrl}support-category/`;

    static supportReadMsgUrl = `${Api.baseUrl}support-read-message/`;

    static getSupportChatUrl = `${Api.baseUrl}get_support_chat/`;

    static supportChatConsnUrl = `${Api.baseUrl}support-conversations/`;

    static supportAdminUrl = `${Api.baseUrl}support-admins/`;

    static chatUploadUrl = `${Api.baseUrl}chat-upload/`;

    static propertiesOrderUrl = `${Api.baseUrl}properties-order/`;

    static optionsListUrl = `${Api.baseUrl}options-list/`;

    static propertyGroupsUrl = `${Api.baseUrl}property-groups/`;

    static featureGroupsUrl = `${Api.baseUrl}feature-groups/`;

    static attributeGroupsUrl = `${Api.baseUrl}get-properties-by-group/`;

    constructor(props) {
        super(props);
        this.state = {};
        this.getBaseUrl = this.getBaseUrl.bind(this);
        this.getImageBaseUrl = this.getImageBaseUrl.bind(this);
    }

    // Get base URL of APIs
    static getBaseUrl() {
        // return `https://${
        //     Api.isStaging
        //         ? 'zf3a0kdlxb.execute-api.me-south-1.amazonaws.com/dev'
        //         : 'pp7566y8ui.execute-api.me-south-1.amazonaws.com/production'
        // }/api/v1/`;
        return `https://api.libanx.com/api/v1/`;
        // return `https://dev.api.libanx.com/api/v1/`;
        // return `http://192.168.1.1:8000/api/v1/`;
    }

    // Get Image base URL of APIs
    static getImageBaseUrl() {
        // return `https://libanx.s3.me-south-1.amazonaws.com/${Api.isStaging ? 'stag' : 'prod'}/media/`;
        return `https://d1qefok4c9bhpt.cloudfront.net/prod/media/`;
    }
}
